import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import jwtDecode from 'jwt-decode';
import { refreshTokenIfNecessary } from '~/helpers/auth-helpers';
import { decodedToken } from '~/helpers/connection-helper';
import { newRelicCall } from '~/helpers/log-helper';
import logout from '~/helpers/logout-helper';
export default (_ref => {
  var {
    app,
    store
  } = _ref;
  app.router.beforeEach( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (to, from, next) {
      // hack temporaire TUN-7315
      if (to.name.startsWith('market-language-user')) {
        try {
          var tokenDecoded = decodedToken();
          var iatTokenMilliseconds = tokenDecoded.iat * 1000;
          // entre 04/07/2022 00:01 et 06/07/2022 15:00
          // 15h 1657112400000
          // 18h 1657123200000
          if (tokenDecoded.firstname && iatTokenMilliseconds > 1656885660000 && iatTokenMilliseconds < 1657112400000) {
            newRelicCall({
              msg: 'force logout 0607',
              level: 'warn',
              customFilter: 'force-logout'
            });
            yield logout(store);
            next({
              path: "/".concat(to.params.market, "/").concat(to.params.language, "/login"),
              query: {
                redirectUrl: to.fullPath
              }
            });
            return;
          }
        } catch (error) {
          // do nothing
        }
      }
      // hack fin
      if (from.name) yield refreshTokenIfNecessary({
        app,
        store
      });
      var sellerToken = app.$cookies.get('MDM_SELLER_TOKEN');
      if (sellerToken) store.dispatch('seller/setSeller', jwtDecode(sellerToken));
      store.dispatch('routeNavigation/updateCurrentRoute', to);
      store.dispatch('routeNavigation/updatePreviousRoute', from);
      next();
    });
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
});